import { RefreshCw, WifiOff } from 'lucide-react';
import { Button } from '@fas/ui';
import { applyUpdate, useOnlineStatus, usePwaStore } from '@/lib/pwa';

/**
 * Connectivity and "new version" notices (SPEC §57, §63 "No internet": show a clear state and
 * never pretend attendance succeeded). Text, not colour alone.
 */
export function PwaStatus() {
  const online = useOnlineStatus();
  const updateReady = usePwaStore((s) => s.updateReady);
  if (online && !updateReady) return null;
  return (
    <div className="print:hidden">
      {!online ? (
        <div role="status" className="flex items-center gap-2 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-950">
          <WifiOff className="size-4 shrink-0" aria-hidden />
          <span>
            <strong className="font-semibold">You’re offline.</strong> Clocking in and out needs a connection; the information shown was loaded earlier.
          </span>
        </div>
      ) : null}
      {updateReady ? (
        <div role="status" className="flex flex-wrap items-center gap-2 border-b border-blue-200 bg-blue-50 px-4 py-2 text-sm text-blue-950">
          <RefreshCw className="size-4 shrink-0" aria-hidden />
          <span>A new version of the app is available.</span>
          <Button size="sm" variant="outline" onClick={applyUpdate}>
            Reload now
          </Button>
        </div>
      ) : null}
    </div>
  );
}
